<div class="form-group {{ displayAsRow() ? 'd-flex align-items-center justify-content-between w-100 gap-3' : '' }}">
  @if (label()) {
    <div class="d-flex align-items-center gap-1" [class.mb-2]="!displayAsRow()">
      <label class="font-14 text-primary m-0 d-flex align-items-center gap-1" [for]="formControlName()">
        <span>{{ label()! | translate }}</span>

        <ng-content select="[additionalLabel]" />
      </label>

      @if (isRequired) {
        <span class="text-danger">*</span>
      }
    </div>
  }

  <div class="quantity-wrapper d-flex align-items-center" [id]="formControlName()">
    <app-button
      btnClass="btn-count without-shadow primary border-radius-0"
      [disabled]="((!value && !countValue()) || disableMinus() || disabled) && countValue() <= min"
      (onClick)="minus()"
    >
      <em class="db-icon-minus font-18"></em>
    </app-button>

    @if (withInput()) {
      <input
        #inputRef
        type="number"
        class="quantity-input form-control border-radius-0 text-primary"
        [id]="formControlName()"
        [formControl]="control"
        [readonly]="disabled"
        (input)="inputValue.emit(value); control ? countValue.set(value) : null; resizeInput(inputRef)"
        (keypress)="onKeyPress($event)"
        [value]="value || count() || 0"
        [min]="min"
        [max]="max"
      />
      <span #mirrorSpan class="mirror-span"></span>
    } @else {
      <span class="quantity text-middle m-0 p-0 d-flex align-items-center justify-content-center font-16" [id]="formControlName()">
        {{ value || count() || 0 }}
      </span>
    }

    <app-button btnClass="btn-count without-shadow primary border-radius-0" [disabled]="disablePlus() || disabled" (onClick)="plus()">
      <em class="db-icon-plus text-primary font-18"></em>
    </app-button>
  </div>

  @if (control && control.errors && control.touched) {
    <mat-error class="font-12 text-danger">
      {{ control.errors | validationHandler }}
    </mat-error>
  }
</div>
